<template>
	<v-select
		:id="id"
		:label="label"
		:loading="loading"
		:disabled="disabled"
		:readonly="readonly"
		:multiple="multiple"
		:clearable="clearable"
		:items="items"
		:rules="rules"
		item-color="blue darken-4"
		:item-text="itemText"
		:item-value="itemValue"
		:hide-details="hideDetails"
		outlined
		:class="{ ...customClass, 'mt-3': !hideTopMargin }"
		v-model="selectinput"
		:placeholder="btx_placeholder"
		:append-outer-icon="appendOuterIcon"
		v-on:click:clear="$emit('click:clear', true)"
		v-on:click:append-outer="$emit('click:append-outer', true)"
		v-on:change="$emit('change', selectinput)"
	>
		<template v-slot:selection="{ item, index }">
			<template v-if="index === 0">
				<span v-if="itemText" class="mr-2">{{ item[itemText] }}</span>
				<span v-else class="mr-2">{{ item }}</span>
			</template>
			<span v-if="index === 1" class="grey--text text-caption"> (+{{ value.length - 1 }} more) </span>
		</template>
		<template v-slot:no-data>
			<v-list-item>
				<v-list-item-title v-html="`No ${placeholder} Found.`"></v-list-item-title>
			</v-list-item>
		</template>
	</v-select>
</template>
<script>
export default {
	name: "select-input",
	model: {
		prop: "value",
		event: "change",
	},
	props: {
		value: {
			type: [Object, Number, String, Array],
			default: null,
		},
		hideTopMargin: {
			type: Boolean,
			default: false,
		},
		items: {
			type: Array,
			required: true,
			default: () => {
				return [];
			},
		},
		rules: {
			type: [Array, Object],
			default: () => {
				return [];
			},
		},
		customClass: {
			type: String,
			default: "pt-0",
		},
		placeholder: {
			type: String,
			default: null,
		},
		appendOuterIcon: {
			type: String,
			default: null,
		},
		id: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: null,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		itemText: {
			type: String,
			default: "text",
		},
		itemValue: {
			type: String,
			default: "value",
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		readonly: {
			type: Boolean,
			default: false,
		},
		multiple: {
			type: Boolean,
			default: false,
		},
		clearable: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		value: {
			deep: true,
			immediate: true,
			handler(param) {
				this.selectinput = param;
			},
		},
	},
	data() {
		return {
			selectinput: null,
		};
	},
	mounted() {
		this.selectinput = this.value;
	},
	computed: {
		btx_placeholder() {
			return `Select ${this.placeholder}`;
		},
	},
};
</script>
